import { defineMessages } from 'react-intl';

export default defineMessages({
  cancel: {
    id: 'email-modal.cancel',
    defaultMessage: 'Cancel',
  },
  sendEmail: {
    id: 'email-modal.confirm',
    defaultMessage: 'Send',
  },
  messageLabel: {
    id: 'email-modal.message-label',
    defaultMessage: 'Message',
  },
  toLabel: {
    id: 'email-modal.to-label',
    defaultMessage: 'To',
  },
  subjectLabel: {
    id: 'email-modal.subject-label',
    defaultMessage: 'Subject',
  },
  messageRequired: {
    id: 'email-modal.message-required',
    defaultMessage: 'A message is required to send this email',
  },
  legalNotice: {
    id: 'email-modal.legal-notice',
    defaultMessage: 'By using this feature, you agree to comply with <a>Usage Guidelines</a>.',
  },
});
